import { CardContent, Card, CardHeader, CardTitle } from '../ui/card';
import { clubApi } from '@repo/api-client';
import { toast } from 'sonner';
import { getDiffValues } from '@/lib/utils';
import { useCurrentClub } from '@/hooks/use-current-club';
import { useForm } from '@repo/ui/hooks/use-form';
import { Input } from '@repo/ui/components/form/input';
import { Button } from '@repo/ui/components/button';

export function Description() {
  const club = useCurrentClub();
  const { ref, errors, values } = useForm({
    initialValues: club,
    onSubmit: async () => {
      const diffValues = getDiffValues(club, values);
      await clubApi.update(club.id, diffValues);
      toast.success('Descripción actualizada correctamente');
    },
  });
  return (
    <Card>
      <CardHeader>
        <CardTitle>Descripción</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <form ref={ref} className="flex flex-col gap-4">
          <Input
            label="Descripción"
            name="description"
            errors={errors}
            required
            minLength={3}
            maxLength={30}
            placeholder="Describe tu club de pádel: instalaciones, servicios, ambiente, etc."
            type="textarea"
            rows={4}
          />
          <Button type="submit">Guardar</Button>
        </form>
      </CardContent>
    </Card>
  );
}
